import { neg } from '../booleans'

import { isEmpty } from './isEmpty'

export const isNotEmpty = neg(isEmpty)
